import { render, staticRenderFns } from "./DamageLossesDetail.vue?vue&type=template&id=44ffe5fc"
import script from "../../controllers/damage-losses/damage-losses-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/damage-losses/damage-losses-detail.js?vue&type=script&lang=js&external"
import style0 from "./DamageLossesDetail.vue?vue&type=style&index=0&id=44ffe5fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports